import { render, staticRenderFns } from "./offer-configuration-details.vue?vue&type=template&id=1bb61c9d&"
import script from "./offer-configuration-details.vue?vue&type=script&lang=js&"
export * from "./offer-configuration-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports